import { UIState, type Breakpoint } from "@hydra/core/uiState";
import type { Plugin } from "../core/plugin";

class UIObserverPlugin implements Plugin {
  private unsubscribeSidebar?: () => void;

  constructor(private el: HTMLElement) {}

  init(): void {
    this.handleResize();
    window.addEventListener("resize", this.handleResize.bind(this));

    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll.bind(this));

    const uiState = UIState.getInstance();
    this.unsubscribeSidebar = uiState.subscribe<boolean>(
      "isSidebarOpen",
      (newValue) => {
        if (newValue) {
          this.el.classList.add("fixed");
        } else {
          this.el.classList.remove("fixed");
        }
      },
    );
  }

  private handleResize(): void {
    const uiState = UIState.getInstance();
    const newViewportWidth = document.body.clientWidth;
    const newViewportHeight = document.body.clientHeight;

    if (uiState.viewportWidth !== newViewportWidth) {
      uiState.viewportWidth = newViewportWidth;
    }

    if (uiState.viewportHeight !== newViewportHeight) {
      uiState.viewportHeight = newViewportHeight;
    }

    const w = newViewportWidth;
    let newBreakpoint: Breakpoint;
    if (w < 640) newBreakpoint = "xs";
    else if (w < 768) newBreakpoint = "sm";
    else if (w < 1024) newBreakpoint = "md";
    else if (w < 1280) newBreakpoint = "lg";
    else newBreakpoint = "xl";

    if (uiState.currentBreakpoint !== newBreakpoint) {
      uiState.currentBreakpoint = newBreakpoint;
    }
  }

  private handleScroll(): void {
    const uiState = UIState.getInstance();
    const headerHeight = document.querySelector("header")?.clientHeight || 0;
    const topBannerHeight =
      document.querySelector(".dsc-co-topBanner")?.clientHeight || 0;
    const isHeaderSticked =
      window.scrollY > this.el.offsetTop + headerHeight + topBannerHeight;
    if (uiState.isHeaderSticked !== isHeaderSticked) {
      uiState.isHeaderSticked = isHeaderSticked;
    }

    const scrollTop = window.scrollY;
    const scrollHeight = document.body.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    const isAtPageEnd = scrollTop + clientHeight >= scrollHeight - 1;
    if (uiState.isAtPageEnd !== isAtPageEnd) {
      uiState.isAtPageEnd = isAtPageEnd;
    }
  }
}

export { UIObserverPlugin };
